import { absolutePath } from "./absolutePath";

const BASE_PATH = "connect/recommendations";

export const recommendations = {
  index: (params = {}) => absolutePath(`${BASE_PATH}`, params),
  dismiss: (id: string) => absolutePath(`${BASE_PATH}/${id}/dismiss`),
};
